/* eslint-disable @typescript-eslint/no-invalid-this, @typescript-eslint/ban-ts-comment */
export function timer(fn: string | any, t: number) {
  let timerObj: ReturnType<typeof setInterval> | null = setInterval(fn, t);

  // @ts-ignore
  this.stop = function () {
    if (timerObj) {
      clearInterval(timerObj);
      timerObj = null;
    }

    return this;
  };

  // @ts-ignore
  this.start = function () {
    if (!timerObj) {
      this.stop();
      timerObj = setInterval(fn, t);
    }

    return this;
  };

  // @ts-ignore
  this.reset = function (newT = t) {
    t = newT;

    return this.stop().start();
  };
}
/* eslint-enable @typescript-eslint/no-invalid-this, @typescript-eslint/ban-ts-comment */
